/* eslint-disable prefer-spread */
/* eslint-disable max-lines */
import { Button, Col, Modal, Row } from 'reactstrap';
import { useEffect, useState } from 'react';
import { PDFDocument } from 'pdf-lib';
import { safeSetTextField } from '../../../../helpers/pdfFieldHelpers';
import { drawSignatureImage } from '../../../../helpers/embedSignatureImage';

type I9SpanishDocumentViewModalProps = {
  isOpen: boolean;
  data: any;
  toggleModal: (e?: any) => void;
};

const I9SpanishDocumentViewModal = ({ isOpen, data, toggleModal }: I9SpanishDocumentViewModalProps) => {
  const [pdf, setPdf] = useState('');

  useEffect(() => {
    if (isOpen) {
      createPdf();
    }
  }, [isOpen]);

  const pdfUrl =
    'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/i-9-spanish.pdf';

  const coordinatesSign = {
    x: 60,
    y: 395,
    height: 30,
    opacity: 1,
  };

  const coordinatesSignSupervisor = {
    x: 260,
    y: 355,
    height: 30,
    opacity: 1,
  };

  const readOnlyFields = (pdfForm: any) => {
    try {
      const fieldNames = pdfForm.getFields();
      for (const f of fieldNames) {
        const type = f.constructor.name;
        const fieldName = f.getName();
        if (type === 'PDFTextField') {
          pdfForm.getTextField(fieldName).enableReadOnly();
        }
        if (type === 'PDFDropdown') {
          pdfForm.getDropdown(fieldName).enableReadOnly();
        }
        if (type === 'PDFCheckBox') {
          pdfForm.getCheckBox(fieldName).enableReadOnly();
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const createPdf = async () => {
    try {
      if (!data) return;
      const url = data?.uploadedPdf || pdfUrl || '';
      const arrayBuffer = await fetch(url).then((res) => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(arrayBuffer);
      const pdfForm = pdfDoc.getForm();
      readOnlyFields(pdfForm);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      if (firstPage && data?.options?.signPng) {
        const pngImage = await pdfDoc.embedPng(data?.options?.signPng);
        drawSignatureImage(firstPage, pngImage, coordinatesSign);
      }

      const secondPage = pages?.[1];
      if (secondPage && data?.options?.signatureSupervisor) {
        const pngImageSupervisor = await pdfDoc.embedPng(data?.options?.signatureSupervisor);
        drawSignatureImage(secondPage, pngImageSupervisor, coordinatesSignSupervisor);
      }

      const formFieldsValues = data?.options?.formFieldsValues || [];
      for (const f of formFieldsValues) {
        const fieldForm = data?.options?.formFields[f?.fieldIndex];
        if (f?.fieldType === 'PDFTextField' && f?.fieldValue) {
          safeSetTextField(pdfForm, fieldForm?.fieldName, `${f?.fieldValue}`);
        }
        if (f?.fieldType === 'PDFDropdown' && f?.fieldValue) {
          try {
            const field = pdfForm.getDropdown(fieldForm?.fieldName);
            field.enableReadOnly();
            if (f?.fieldValue) field.select(f?.fieldValue);
          } catch (e) {
            console.error(`[I9SpanishView] Failed to set dropdown "${fieldForm?.fieldName}":`, e);
          }
        }
        if (f?.fieldType === 'PDFCheckBox' && f?.fieldValue === 'true') {
          try {
            const field = pdfForm.getCheckBox(fieldForm?.fieldName);
            field.enableReadOnly();
            field.check();
          } catch (e) {
            console.error(`[I9SpanishView] Failed to set checkbox "${fieldForm?.fieldName}":`, e);
          }
        }
      }

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes as any], { type: 'application/pdf' });
      const docUrl = URL.createObjectURL(blob);
      setPdf(docUrl);
    } catch (e) {
      console.log(e);
    }
  };

  const handleDownloadPdf = () => {
    if (!pdf) {
      return;
    }
    const link = document.createElement('a');
    link.href = pdf;
    const filename = `i9.pdf`;
    link.setAttribute('download', filename);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Modal className="modal-dialog-centered" size="xl" isOpen={isOpen} toggle={(e: any) => toggleModal(e)}>
        <div className="modal-header pb-1">
          <h5 className="modal-title">I9 - Spanish</h5>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={(e) => toggleModal(e)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body pt-0">
          <Row className="mt-2">
            <Col md="12" lg="12">
              <div className="d-flex justify-content-end">
                <Button color="primary" onClick={handleDownloadPdf} size="sm">
                  Download (PDF)
                </Button>
              </div>
            </Col>
            <Col lg="12" className="mt-4" style={{ maxHeight: '500px', overflow: 'scroll' }}>
              <iframe src={pdf} style={{ minHeight: 500, width: '100%' }} />
            </Col>
          </Row>
        </div>
      </Modal>
    </>
  );
};

export default I9SpanishDocumentViewModal;
